// src/components/latest-results/LatestResultsHeader.jsx
import { translations } from "../../translation/translate";
import { useSelector } from "react-redux";
export default function LatestResultsHeader() {
  const langData = useSelector((state) => state.langSlice.langData);
    return (
      <div className="relative w-full h-[15%] bg-[#845BB3] flex items-center justify-center rounded-t-2xl">
        <div
          onClick={() => window.history.back()}
          className="absolute left-10 bg-white px-4 py-2 rounded cursor-pointer text-[#845BB3] font-bold shadow-sm"
        >
        {translations[langData].GoBack}
        </div>
        <h2 className="text-2xl my-2 font-semibold text-white">Latest Result</h2>
      </div>
    );
  }
  